<div class="table-container" tabindex="0">
    <div class="table-header twc-body twc-mb-0">
        <div *ngFor="let col of columns" class="table-header-cell" [style.flex]="col.width ?? 'auto'">
            {{ col.name | translate}}
        </div>
    </div>
    <div class="table-body" twcInfiniteScroll (triggered)="onLoadMoreData()">
        <div *ngFor="let row of data" class="table-row twc-body twc-mb-0 align-center" twcInfiniteScrollContent>
            <div *ngFor="let col of columns" class="table-cell" [ngSwitch]="col.type"
                [style.flex]="col.width ?? 'auto'">
                <ng-container *ngSwitchCase="'string'">
                    {{ (row | resolveProperty: col.field) | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'date'">
                    {{row | resolveProperty: col.field | localizedDate: col.dateFormat}}
                </ng-container>
            </div>
        </div>
    </div>
    <div *ngIf="isLoading"
        class="position-absolute width-100 twc-d-flex align-center justify-content-center loader-container">
        <twc-loader size="large"></twc-loader>
    </div>
</div>